import { createModal } from '/@/core/elements/modal'

interface ImageDetailModalData {
  imageId: string
}

const { api, component } = createModal<ImageDetailModalData>(
  'ImageDetailModal',
  () => import('./ImageDetailModal.vue'),
  {
    imageId: '',
  },
)

export const useImageDetailModal = api
export default component
